
(function () {
    "use strict";

    var MAX_CALLS = 6;
    var WINDOW_MS = 2000;
    var PAUSE_MS = 3000;
    var MAX_PATCH_ATTEMPTS = 80;
    var RETRY_DELAY_MS = 250;
    var LOG = "[Custom][YMAL] reInsertWidget guard:";

    function guard() {
        var ymal = window.tlYMAL;
        if (!ymal || typeof ymal.reInsertWidget !== "function" || ymal.__reInsertGuard) return false;
        var original = ymal.reInsertWidget;
        var calls = [];
        var pausedUntil = 0;
        ymal.__reInsertGuard = true;
        ymal.reInsertWidget = function () {
            try {
                var now = Date.now();
                if (now < pausedUntil) return;
                calls = calls.filter(function (t) { return now - t < WINDOW_MS; });
                calls.push(now);
                if (calls.length > MAX_CALLS) {
                    pausedUntil = now + PAUSE_MS;
                    calls = [];
                    console.log(LOG, "loop detected, paused " + PAUSE_MS + "ms");
                    return;
                }
            } catch (error) {
                console.log(LOG, "check failed, pass through", error);
            }
            return original.apply(this, arguments);
        };
        return true;
    }

    var attempts = 0;
    (function tryGuard() {
        try {
            if (guard()) return;
        } catch (error) {
            console.log(LOG, "install failed, skip", error);
            return;
        }
        if (++attempts < MAX_PATCH_ATTEMPTS) setTimeout(tryGuard, RETRY_DELAY_MS);
    })();
})();
